import { Component } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { FooterComponent } from './components/footer/footer.component';
import { AuthStatusComponent } from './components/auth/auth-status.component';

@Component({
  selector: 'msi-self-service-root',
  imports: [RouterLink, RouterOutlet, FooterComponent, AuthStatusComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {}
